import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { RegistryOtpPort } from '../../../domain/commerce-registry/ports/registry-otp.port';
import type {
  RegistryOtpGenerateParams,
  RegistryOtpGenerateResult,
  RegistryOtpValidateParams,
  RegistryOtpValidateResult,
} from '../../../domain/commerce-registry/models/registry-otp.model';
import { ENVIRONMENT } from '../../../../environments/environment';

/** API envelope (legacy saas style). */
interface OtpApiEnvelope<T> {
  data?: T;
  code?: number;
  message?: string;
}

@Injectable()
export class RegistryOtpApiAdapter extends RegistryOtpPort {
  constructor(private readonly http: HttpClient) {
    super();
  }

  generate(params: RegistryOtpGenerateParams): Observable<RegistryOtpGenerateResult> {
    const base = ENVIRONMENT.apiBaseLeal?.trim();
    if (!base) {
      return throwError(() => new Error('apiBaseLeal is not configured'));
    }
    const url = `${base.replace(/\/$/, '')}/v1/otp/otp/generate`;
    const body = {
      email: params.email,
      cellphone: params.cellphone,
      countryCode: params.countryCode,
      commerceId: params.commerceId,
      flow: params.flow,
    };
    return this.http
      .post<OtpApiEnvelope<{ otpId: string; currentValidationChannel: string }>>(url, body)
      .pipe(
        map((res) => {
          const data = res?.data;
          if (!data?.otpId) {
            throw new Error(res?.message ?? 'Invalid OTP generate response');
          }
          return {
            otpId: data.otpId,
            currentValidationChannel: String(data.currentValidationChannel ?? 'EMAIL'),
          };
        }),
      );
  }

  validate(params: RegistryOtpValidateParams): Observable<RegistryOtpValidateResult> {
    const base = ENVIRONMENT.apiBaseLeal?.trim();
    if (!base) {
      return throwError(() => new Error('apiBaseLeal is not configured'));
    }
    const url = `${base.replace(/\/$/, '')}/v1/otp/otp/validate`;
    const body = { otpId: params.otpId, otpCode: params.otpCode };
    return this.http.post<OtpApiEnvelope<{ isValid: boolean }>>(url, body).pipe(
      map((res) => ({
        isValid: Boolean(res?.data?.isValid),
      })),
    );
  }
}
